import {FC, useEffect, useState} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/de'
import '@formatjs/intl-relativetimeformat/locale-data/es'
import '@formatjs/intl-relativetimeformat/locale-data/fr'
import '@formatjs/intl-relativetimeformat/locale-data/ja'
import '@formatjs/intl-relativetimeformat/locale-data/zh'

import {resolveMessages} from '../../app/i18n/loadMessages'
import {syncAppDateLocale} from '../../app/utils/date'
import {LayoutSplashScreen} from '../layout/core'
import {WithChildren} from '../helpers'

const I18nProvider: FC<WithChildren> = ({children}) => {
  const locale = useLang()
  const [messages, setMessages] = useState<Record<string, string> | null>(null)

  useEffect(() => {
    syncAppDateLocale(locale)
  }, [locale])

  useEffect(() => {
    let cancelled = false

    setMessages(null)
    resolveMessages(locale).then((merged) => {
      if (!cancelled) {
        setMessages(merged)
      }
    })

    return () => {
      cancelled = true
    }
  }, [locale])

  if (!messages) {
    return <LayoutSplashScreen />
  }

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
